import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import { ArrowLeft, Download, Clock } from "lucide-react";
import { API } from "../lib/site";
import { Reveal } from "../components/Reveal";

export default function NewsDetail() {
  const { id } = useParams();
  const [post, setPost] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    let active = true;
    axios.get(`${API}/news/${id}`)
      .then((r) => active && setPost(r.data))
      .catch(() => active && setNotFound(true));
    return () => { active = false; };
  }, [id]);

  const fmtDate = (d) => d && new Date(d).toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" });

  if (notFound) {
    return (
      <div className="min-h-screen bg-ink flex items-center justify-center" data-testid="news-notfound">
        <div className="text-center">
          <p className="overline mb-4">404</p>
          <h1 className="font-heading text-4xl font-bold uppercase text-textmain mb-6">Post not found</h1>
          <Link to="/newsroom" className="btn-ghost-tactical">Back to Newsroom</Link>
        </div>
      </div>
    );
  }

  return (
    <div data-testid="news-detail-page" className="bg-ink">
      <section className="pt-40 md:pt-48 pb-20">
        <div className="container-x max-w-3xl">
          <Reveal>
            <Link to="/newsroom" data-testid="back-to-newsroom" className="inline-flex items-center gap-2 text-sm uppercase tracking-widest text-textmuted hover:text-steel transition-colors mb-10">
              <ArrowLeft size={16} /> Newsroom
            </Link>
            {post && (
              <>
                <div className="flex items-center gap-4 mb-6 flex-wrap">
                  <span className="text-xs uppercase tracking-widest text-steel border border-steel/30 px-3 py-1">{post.category}</span>
                  <span className="text-xs text-textmuted">{fmtDate(post.date)}</span>
                  <span className="text-xs text-textmuted flex items-center gap-1"><Clock size={12} /> {post.read_time}</span>
                </div>
                <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold uppercase tracking-tight text-textmain leading-[0.95] mb-8">
                  {post.title}
                </h1>
                <p className="text-lg text-textmain leading-relaxed mb-10 pb-10 border-b border-white/10">{post.excerpt}</p>

                {post.has_pdf && (
                  <a
                    href={`${API}/news/${post.id}/pdf`}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="download-pdf"
                    className="btn-tactical group mb-12"
                  >
                    <Download size={18} /> Download {post.pdf_filename ? "Document" : "PDF"}
                  </a>
                )}

                {post.body && (
                  <div className="prose-invert max-w-none">
                    <p className="text-textmuted text-base md:text-lg leading-relaxed whitespace-pre-line" data-testid="news-body">
                      {post.body}
                    </p>
                  </div>
                )}
              </>
            )}
          </Reveal>
        </div>
      </section>
    </div>
  );
}
